import { Link } from "react-router-dom";
import { siteInfo, stats } from "@/mocks/site";

const quickTags = ["深夜聚会", "代言变动", "切片剪辑", "选角讨论", "复出动态"];

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20warm%20cinematic%20backdrop%20of%20a%20modern%20editorial%20newsroom%20with%20amber%20and%20crimson%20light%20streaks%2C%20deep%20brown%20shadows%2C%20soft%20floating%20particles%2C%20moody%20atmospheric%20texture%2C%20no%20people%2C%20high%20detail%2C%20wide%20composition&width=1600&height=900&seq=hero-heiliaobaike-main&orientation=landscape"
          alt="黑料百科 首页主视觉背景"
          title="黑料百科 人物词条与话题档案"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/60"></div>
      </div>

      <div className="relative w-full px-4 py-16 md:px-6 md:py-24">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-300/40 bg-primary-950/40 px-3 py-1 text-xs text-primary-200 backdrop-blur">
            <i className="ri-bookmark-3-line"></i>
            人物词条 · 话题时间线 · 每日更新
          </span>
          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
            {siteInfo.name}
            <span className="mt-3 block text-lg font-normal text-white/80 md:text-2xl">
              想查明星、网红、艺人的话题脉络？来这里按时间线一次看完
            </span>
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-white/75 md:text-base">
            {siteInfo.slogan}。人物背景、事件节点、各方回应，按日期整理成结构化档案，吃瓜群众必备参考。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/ranking"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line"></i>
              查看今日热度榜单
            </Link>
            <Link
              to="/category/star"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/30 bg-white/10 px-6 py-3 text-sm text-white backdrop-blur transition-colors hover:bg-white/20"
            >
              <i className="ri-layout-grid-line"></i>
              按分类浏览词条
            </Link>
          </div>

          <div className="mt-7 flex flex-wrap items-center gap-2">
            <span className="text-xs text-white/60">热搜标签</span>
            {quickTags.map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs text-white/80"
              >
                #{tag}
              </span>
            ))}
          </div>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-4 border-t border-white/15 pt-6 md:grid-cols-4 md:gap-6">
          {stats.map((item) => (
            <div key={item.label}>
              <dt className="font-heading text-xl font-bold text-white md:text-2xl">{item.value}</dt>
              <dd className="mt-1 text-xs text-white/70 md:text-sm">
                {item.label}
                <span className="mt-0.5 block text-[11px] text-white/45">{item.desc}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}